/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Col_CarrierInputs */

const vi_cdo_col_carrier = /** @type {(inputs: Cdo_Col_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị giao`)
};

/**

* @param {Cdo_Col_CarrierInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_col_carrier = /** @type {((inputs?: Cdo_Col_CarrierInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Col_CarrierInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_col_carrier(inputs)
});